module.exports = __webpack_public_path__ + "b706998318f3427e4ad03418c92524f9.MP3";